import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChiSiamoService } from './chi-siamo.service';
import { HttpClient } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import * as L from 'leaflet';

@Component({
  selector: 'app-chi-siamo',
  templateUrl: './chi-siamo.component.html',
  styleUrls: ['./chi-siamo.component.scss'],
  providers: [ChiSiamoService, HttpClient]
})
export class ChiSiamoComponent implements OnInit, AfterViewInit {
  idExtraAsset: Number = 1;
  listaContatti: any;
  organigrammaList: any;
  descrizioneSezione: any;

  private mapSede: L.Map | undefined;
  private markersLayer: L.LayerGroup = new L.LayerGroup([]);
  private initialMapCenter: L.LatLngExpression = [40.85705250953347, 14.283941209757725];
  private initialMapZoom: number = 17;
  defaultColDef: any;

  private customIcon = L.icon({
    iconUrl: './assets/img/spotlight-poi2-small.png',
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -35]
  });

  constructor(
    public router: Router,
    public restService: ChiSiamoService,
    private fb: FormBuilder,
    private _sanitizer: DomSanitizer,
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true
    };
  }

  ngOnInit(): void {
    this.findAllContatti();
    this.findAllOrganigramma();
    this.findDescrizione();
  }

  ngAfterViewInit(): void {
    this.initMap();
  }


  routeTo(path: any) {
    this.router.navigate([path]);
  }

  findAllContatti() {
    this.restService.findAllContatti().then(
      res => {
        if (res) {
          this.listaContatti = res.contattiBindList;
        }
      }
    ).catch(error => {
      this.listaContatti = {};
    });
  }
  

  findAllOrganigramma() {
    this.restService.findAllOrganigramma().then(
      res => {
        let modelAggregate: { [key: number]: any } = {};

        for (let k in res.organigrammaBindList) {
          let item = res.organigrammaBindList[k];
          let tipo = item.idTipoOrganigramma;

          if (!modelAggregate[tipo]) {
            modelAggregate[tipo] = {
              idOrganigramma: tipo,
              elements: []
            };
          }

          modelAggregate[tipo].elements.push({
            nome: item.nome,
            competenza: item.competenza
          });
        }

        // Converti l'oggetto in un array ordinato
        this.organigrammaList = Object.values(modelAggregate);
      }
    ).catch(error => {
      this.organigrammaList = {};
    });
  }

  findDescrizione() {

    /* this.restService.findAllDescrizione().then(
      res => {
        if (res) {
          this.descrizioneSezione = this._sanitizer.bypassSecurityTrustHtml(res[0].descrizione);
        }
      }
    ) */
    this.restService.findExtraById(this.idExtraAsset).then(
      res => {
        if (res) {
          this.descrizioneSezione = this._sanitizer.bypassSecurityTrustHtml(res.descrizione);
        }
      }

    )
  }


  getRuoloDescrizione(idRuolo): string {
    switch (idRuolo) {
      case 1:
        return "Dirigente";
      case 2:
        return "Area Meteo";
      case 3:
        return "Area Idro-Pluvio";
      case 4:
        return "Area Tecnico-Informatica";
      default:
        return "Ruolo non disponibile";
    }

  }

  getRuoloOrganigramma(idRuolo): string {
    switch (idRuolo) {
      case 1:
        return "Dirigente";
      case 2:
        return "Area meteorologica, idrologica e idraulica";
      case 3:
        return "Area tecnico-informatica";
      default:
        return "Ruolo non disponibile";
    }
  }

  private renderPreloadedMarkers(markers: L.Marker[]): void {
    this.markersLayer.clearLayers();
    const bounds = new L.LatLngBounds([]);

    markers.forEach((marker) => {
      this.markersLayer.addLayer(marker);
      bounds.extend(marker.getLatLng());
    });

    if (bounds.isValid()) {
      this.mapSede?.fitBounds(bounds);
    } else {
      this.mapSede?.setView(this.initialMapCenter, this.initialMapZoom);
    }
  }

  private initMap(): void {

    this.mapSede = L.map('mapSede', {
      center: this.initialMapCenter,
      zoom: this.initialMapZoom,
      scrollWheelZoom: false
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
       maxZoom: 18,
      attribution: 'Protezione Civile Regione Campania'
    }).addTo(this.mapSede);

    /* 
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
  attribution: '&copy; CartoDB & OpenStreetMap',
  subdomains: 'abcd',
  maxZoom: 19
}).addTo(this.mapSede);
 */

    /* L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: 'Protezione Civile Regione Campania'
    }).addTo(this.mapSede); */


    this.markersLayer.addTo(this.mapSede);

    const marker = L.marker([40.85705250953347, 14.283941209757725], {
      icon: this.customIcon,
      title: "Centro Funzionale Multirischi - Protezione Civile Regione Campania - Centro Direzionale isola C3"
    })
      .addTo(this.mapSede)
      .bindPopup("Centro Funzionale Multirischi - Protezione Civile Regione Campania - Centro Direzionale isola C3")
  }

}
